import { render } from "./EditCourse.vue?vue&type=template&id=c8cb4cf8&scoped=true"
import script from "./EditCourse.vue?vue&type=script&lang=js"
export * from "./EditCourse.vue?vue&type=script&lang=js"

import "./EditCourse.vue?vue&type=style&index=0&id=c8cb4cf8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c8cb4cf8"

export default script